import * as React from 'react';
import { createPortal } from 'react-dom';

import * as styles from './ErrorWrapper.css';

export const ErrorWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return createPortal(
    <div className={styles['container']}>
      <div className={styles['notifications']}>{children}</div>
    </div>,
    document.body,
  );
};
